import React, { useContext, useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import { AuthContext, base_url } from "../../../context/Authcontext";
import toast, { Toaster } from "react-hot-toast";
import { Modal } from 'bootstrap';

const BrowseWithdrawl = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [withdrawList, setWithdraw] = useState(null);
  const [id, setId] = useState({ id: null, isDenied: null });
  const [refreshData, setRefreshData] = useState(false);
  const [showPopUpAccept, setShowPopUpAccept] = useState(null);
  const [showPopUpRej, setShowPopUpRej] = useState(null);
  const [permit, setPermit] = useState([]);
  const [show, setShow] = useState(0);
  const { getRoles } = useContext(AuthContext);
  
  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const fetchRoles = async () => {
    const auth = localStorage.getItem('admin');
    const role = localStorage.getItem('role');
  
    try {
      const roles = await getRoles(auth, role);
  
      roles.forEach((role) => {
        const values = Object.values(role);
  
        values[0].forEach((val) => {
          if (Object.keys(val).includes('pending withdraw')) {
            const permit = Object.values(val);
            setPermit(permit[0]);
          }
        });
      });
    } catch (error) {
      console.log('Error fetching roles:', error);
    }
  };

  useEffect(() => {
    const fetchWithdrawlList = async () => {
      try {
        const auth = localStorage.getItem("admin");
        const res = await axios.get(`${base_url}/api/webapi/withdraw/pending`, {
          headers: {
            Accept: "application/json",
            Authorization: `${auth}`,
          },
        });
        if (res.data.status) {
          setWithdraw(res.data.withdrawList);
        }
      } catch (err) {
        console.log("Error fetching withdrawal list:", err);
        toast.error("Failed to load withdrawal data");
      }
    };
    
    fetchWithdrawlList();
    fetchRoles();
  }, [refreshData, getRoles]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return (
    <div className="wrapper">
    
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
        <div>
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1>
                    Pending withdrawals{" "}
                    <img
                      data-v-7b283485
                      width="35px"
                      height="35px"
                      src="/assets/images/withdraw.png"
                      className="chackImg"
                      alt="withdraw icon"
                    />
                  </h1>
                </div>
              </div>
            </div>
          </section>
          {/* Default box */}
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">withdrawals Requests</h3>
              <div className="align-items-center d-flex gap-2 px-2">
                <button
                  className="withdraw_tab_button active"
                  id="inr_w_tab"
                  type="BANK_CARD"
                >
                  BANK CARD
                </button>
                <button
                  className="withdraw_tab_button"
                  id="usdt_w_tab"
                  type="USDT_ADDRESS"
                >
                  USDT ADDRESS
                </button>
              </div>
              
              <div className="card-tools">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="collapse"
                  title="Collapse"
                >
                  <i className="fas fa-minus" />
                </button>
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  title="Remove"
                >
                  <i className="fas fa-times" />
                </button>
              </div>
            </div>
            <div className="card-body p-0" style={{ overflowY: "hidden" }}>
              <table className="table table-striped projects">
                <thead id="table_columns">
                  <tr>
                    <th className="text-center">#</th>
                    <th className="text-center">Phone Number</th>
                    <th className="text-center">Bank Name</th>
                    <th className="text-center">Recipient Name</th>
                    <th className="text-center">Bank Account Number</th>
                    <th className="text-center">IFSC</th>
                    <th className="text-center">UPI Id</th>
                    <th className="text-center">Amount</th>
                    <th className="text-center">Date</th>
                    <th className="text-center">Status</th>
                    <th className="text-center">Accept/Reject</th>
                  </tr>
                </thead>
                <tbody>
                  {withdrawList?.map((ele, index) => {
                    return (
                      <tr key={index} className="text-center">
                        <td>{ele.id}</td>
                        <td>
                          <b>{ele.phoneNumber}</b>
                        </td>
                        <td>
                          <b>{ele.bankName}</b>
                        </td>
                        <td style={{ minWidth: "190px" }}>
                          <b>{ele.recipientName}</b>
                        </td>
                        <td style={{ minWidth: "190px" }}>
                          <b>{ele.bankAccountNumber}</b>
                        </td>
                        <td style={{ minWidth: "190px" }}>
                          <b>{ele.IFSC}</b>
                        </td>
                        <td style={{ minWidth: "190px" }}>
                          <b>--</b>
                        </td>
                        <td>
                          <b>{ele.amount}</b>
                        </td>
                        <td style={{ minWidth: "190px" }}>
                          <b>{ele.today}</b>
                        </td>
                        <td className="project-state">
                          <span className="badge badge-warning">
                            Waiting...
                          </span>
                        </td>
                        <td
                          className="d-flex gap-2 justify-content-center project-actions text-center"
                          style={{ minWidth: "160px", position: "relative" }}
                        >
                          <button
                            className="btn btn-success btn-sm confirm-btn"
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                            onClick={() => {
                              setId({ id: ele.id, isDenied: false });
                              setShow(1);
                             
                            }}
                            onMouseEnter={() => setShowPopUpAccept(index)}
                            onMouseLeave={() => setShowPopUpAccept(null)}
                          >
                            <i className="fa fa-check-circle"></i>
                          </button>
                          {showPopUpAccept === index && (
                            <div className="popup-text show">Accept</div>
                          )}
                          <button
                            className="btn btn-danger btn-sm delete-btn"
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                            onClick={() => {
                              setId({ id: ele.id, isDenied: true });
                              setShow(0);
                            }}
                            onMouseEnter={() => setShowPopUpRej(index)}
                            onMouseLeave={() => setShowPopUpRej(null)}
                          >
                            <i className="fas fa-times-circle"></i>
                          </button>
                          {showPopUpRej === index && (
                            <div className="popup-text-reject show">Reject</div>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <ModalPopUp id={id} setRefreshData={setRefreshData} show={show}  />
      <Toaster position="top-right" reverseOrder={false} />
    </div>
  );
};
const ModalPopUp = ({ id, setRefreshData, show  }) => {
  const { WITHDRAWAL_STATUS_MAP } = useContext(AuthContext);
  const [remarks, setRemarks] = useState("");
  const [proof, setProof] = useState(null);
  const [fileName, setFileName] = useState("No file chosen");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setProof(e.target.files[0]);
      setFileName(e.target.files[0].name);
      toast.success("Proof image uploaded");
    }
  };

  const handleConfirmWithdraw = async (e) => {
    e.preventDefault();
    
    try {
      // Validate proof image when accepting withdrawal
      if (show === 1 && !proof) {
        toast.error("Please upload proof image before confirming");
        return;
      }

      setIsSubmitting(true);
      
      const formData = new FormData();
      
      formData.append('id', id.id);
      formData.append('status', id.isDenied ? WITHDRAWAL_STATUS_MAP.DENIED : WITHDRAWAL_STATUS_MAP.APPROVED);
      formData.append('remarks', remarks);
      
      // Append the file with the key 'proof'
      if (proof) {
        formData.append('proof', proof);
      }

      const auth = localStorage.getItem("admin");
      
      // Log the FormData contents for debugging
      for (let pair of formData.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
      }
      
      const res = await axios.post(
       ` ${base_url}/api/webapi/admin/withdraw/status`,
        formData,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `${auth}`,
          },
        }
      );
      
      if(res.data.status) {
        toast.success(res.data.message || "Withdrawal status updated successfully");
        setRefreshData(prev => !prev);
        
        // const modalElement = document.getElementById('exampleModal');
        // const bootstrapModal = Modal.getInstance(modalElement) || new Modal(modalElement);
        // bootstrapModal.hide();
        const modalElement = document.getElementById('exampleModal');
  if(modalElement){
    modalElement.setAttribute('data-bs-dismiss', 'modal');
    modalElement.click();
    modalElement.removeAttribute('data-bs-dismiss');
  }

        
        
        // Reset form fields
        setRemarks("");
        setProof(null);
        setFileName("No file chosen");
        

      } else {
        toast.error(res.data.message || "Failed to update withdrawal status");
      }
    } catch (err) {
      console.error("Error updating withdrawal status:", err);
      toast.error(err.response?.data?.message || "An error occurred. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                {id.isDenied ? "Reject Withdrawal" : "Accept Withdrawal"}
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <form onSubmit={handleConfirmWithdraw}>
              <div className="modal-body">
                {show === 1 && (
                  <div className="mb-3">
                    <label className="form-label fw-bold">Upload Proof (Required)</label>
                    <div className="input-group">
                      <input
                        type="file"
                        className="form-control"
                        name="proof"
                        onChange={handleFileChange}
                        accept="image/*"
                        required={show === 1}
                      />
                    </div>
                    {fileName && (
                      <small className="text-muted mt-1 d-block">
                        Selected file: {fileName}
                      </small>
                    )}
                  </div>
                )}
                
                <div className="mb-3">
                  <label htmlFor="textAreaExample" className="form-label fw-bold">Remarks</label>
                  <textarea
                    className="form-control"
                    id="textAreaExample"
                    rows="4"
                    placeholder="Type your message here..."
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                  ></textarea>
                </div>
              </div>
              
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  disabled={isSubmitting}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <span>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Processing...
                    </span>
                  ) : (
                    id.isDenied ? "Confirm Rejection" : "Confirm Approval"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default BrowseWithdrawl;